import styled from "styled-components";

import { colorsPalettes, truncateText } from "@similarweb/styles";
import { DropdownButton } from "@similarweb/ui-components";

export const StyledDropdownButton = styled(DropdownButton)<{ hasSelectedValue: boolean }>`
    ${truncateText()};

    color: ${({ hasSelectedValue }) => (hasSelectedValue ? colorsPalettes.carbon[500] : colorsPalettes.carbon[200])};
`;
